export const SEARCH_INPUT_TEXT = {
  /** Figma 기본 placeholder(코드의 헤더 검색) */
  placeholder: '검색어/회사명',
  /** 보조기기가 읽는 기본 이름 */
  label: '검색',
  /** status=loading 일 때 읽는 문구 */
  loading: '검색하는 중',
} as const;
